export default __webpack_public_path__ + "static/media/49.85fc5496.svg";